import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0',
    wrapper: 'group/sort relative flex items-center justify-end',
    label: 'sr-only',
    input:
      'peer invalid:text-error placeholder:text-bg-main-inversion disabled:placeholder:text-inactive disabled:text-inactive group-hover/sort:text-brand-primary block field-sizing-content w-auto appearance-none pr-3 pl-2 font-light text-black outline-none focus:outline-none',
    helperText: 'text-text-inactive px-4 pt-1 text-sm font-light',
    startAdornment: 'group-hover/sort:[&>path]:stroke-brand-primary h-6',
    endAdornment: 'h-6'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-error',
        input: 'text-error'
      }
    },
    withBorder: {
      true: {
        wrapper: 'invalid:border-bg-delete-error border-b-1 border-black'
      },
      false: {
        wrapper: ''
      }
    },
    type: {
      header: {
        wrapper: 'justify-start gap-1 pl-3',
        input:
          'text-icon-main group-hover/sort:text-text-main grow py-3 placeholder:text-gray-700'
      }
    }
  },
  compoundVariants: [
    {
      type: 'header',
      withBorder: true,
      className: {
        wrapper: 'border-text-main focus-within:border-brand-primary'
      }
    }
  ],
  defaultVariants: {
    withBorder: true
  }
});
